import { Component } from '@angular/core';

@Component({
  selector: 'app-journal',
  templateUrl: './journal.html',
  styleUrls: ['./journal.scss']
})
export class JournalComponent {

}